import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_COOLING_TOWER',
  GET: 'GET_COOLING_TOWER',
  CREATE: 'CREATE_COOLING_TOWER',
  EDIT: 'EDIT_COOLING_TOWER',
  DELETE: 'DELETE_COOLING_TOWER',
  DUPLICATE: 'DUPLICATE_COOLING_TOWER',
  CLEAR_ERROR: 'CLEAR_ERROR_COOLING_TOWER',
};

export const clearErrorCoolingTower = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchCoolingTowerByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchCoolingTower(pageSize, page, sorted, filtered, isPublic);
};

export const searchCoolingTower = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_COOLING_TOWER,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listCoolingTower = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchCoolingTower(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getCoolingTower = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_COOLING_TOWER}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createCoolingTower = (name, coolingCap, unitId, powerRequired, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('cooling_capacity', coolingCap);
  formData.set('unit', unitId);
  formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `acct_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_COOLING_TOWER,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editCoolingTower = (id, name, coolingCap, unitId, powerRequired, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (coolingCap) formData.set('cooling_capacity', coolingCap);
  if (unitId) formData.set('unit', unitId);
  if (powerRequired) formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `acct_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_COOLING_TOWER}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteCoolingTower = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_COOLING_TOWER}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateCoolingTower = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_COOLING_TOWER}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/ac_central/cooling_tower_actions.js